import React from 'react';
import { motion } from 'framer-motion';
export function SleepCascadeSection() {
  const steps = [{
    title: 'Baja el cortisol',
    desc: 'Reducimos la hormona del estrés acumulada durante el día.'
  }, {
    title: 'Activa la melatonina',
    desc: 'Estimulamos la hormona del sueño de forma 100% natural.'
  }, {
    title: 'Cierra el día',
    desc: 'Transición suave hacia el descanso sin peleas ni llantos.'
  }];
  return <section className="py-24 px-4 bg-warm-900 text-warm-50 relative overflow-hidden" data-id="element-185">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(212,168,83,0.05)_0%,transparent_70%)] pointer-events-none" data-id="element-186" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-187">
        <div className="text-center mb-16" data-id="element-188">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-bold mb-4 font-heading" data-id="element-189">
            La Cascada del Sueño
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl md:text-2xl text-gold font-medium italic" data-id="element-190">
            Paz en casa antes de las 8:30 PM.
          </motion.p>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="mt-6 text-lg text-warm-100/80 max-w-2xl mx-auto" data-id="element-191">
            Una secuencia simple de 3 pasos que prepara el cerebro infantil para
            dormir profundamente.
          </motion.p>
        </div>

        <div className="relative max-w-3xl mx-auto mb-20" data-id="element-192">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-1/2 left-0 w-full h-px bg-warm-800 -translate-y-1/2 z-0" data-id="element-193" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative z-10" data-id="element-194">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.2
          }} className="bg-warm-800/80 backdrop-blur-sm border border-warm-700/50 rounded-2xl p-6 text-center relative" data-id="element-195">
                <div className="w-10 h-10 rounded-full bg-gold text-warm-900 font-bold flex items-center justify-center mx-auto mb-4 text-lg shadow-[0_0_15px_rgba(212,168,83,0.3)]" data-id="element-196">
                  {index + 1}
                </div>
                <h3 className="text-xl font-bold font-heading mb-2 text-warm-50" data-id="element-197">
                  {step.title}
                </h3>
                <p className="text-warm-100/70 text-sm" data-id="element-198">{step.desc}</p>
              </motion.div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="text-center bg-gold/10 border border-gold/20 rounded-3xl p-8 max-w-2xl mx-auto" data-id="element-199">
          <p className="text-2xl md:text-3xl font-heading font-bold text-gold-light" data-id="element-200">
            Recupera <span className="text-gold" data-id="element-201">2 horas de tu noche</span>
          </p>
          <p className="mt-3 text-lg text-warm-100/90" data-id="element-202">
            para descansar, leer o conectar con tu pareja.
          </p>
        </motion.div>
      </div>
    </section>;
}